import { atom } from 'jotai';

export const localStorageAtom = atom<Record<string, string | null>>({});
